import React, { useEffect, useState } from "react";

export default function Deals() {
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    fetch("/deals.json")
      .then((res) => res.json())
      .then((data) => setDeals(data))
      .catch((err) => console.error("Error loading deals.json:", err));
  }, []);

  return (
    <main className="max-w-6xl mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold mb-4">Latest Deals</h2>

      {deals.length === 0 ? (
        <p>No deals available.</p>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {deals.map((deal) => (
            <a
              key={deal.id}
              href={`#/deal/${deal.dateAdded}`}
              className="border rounded-lg overflow-hidden shadow bg-white block"
            >
              <img
                src={deal.thumbnail || deal.image}
                alt={deal.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="font-semibold">{deal.title}</h3>
                <p className="text-sm text-slate-600">{deal.description}</p>
                <p className="text-xs text-slate-500 mt-2">
                  {new Date(deal.dateAdded).toLocaleDateString()}
                </p>
              </div>
            </a>
          ))}
        </div>
      )}
    </main>
  );
}
